import { Lead } from '../../../types';

/** Callback de cache do histórico — única assinatura usada no app. */
export type LeadHistoryCacheUpdater = (
    id: string,
    value: number,
    stage: string,
    agent: string | null,
    name: string
) => void;

/** No-op compartilhado quando o caller não precisa atualizar cache (DRY). */
export const noopLeadHistoryCache: LeadHistoryCacheUpdater = () => {};

/**
 * Maps a domain lead entity to the frontend Lead interface.
 * Also handles updating the provided cache.
 * 
 * @param domainLead The lead entity from the domain layer
 * @param updateCache Callback to update the lead history cache
 * @returns Mapped Lead object
 */
export const mapDomainLeadToFrontend = (
    domainLead: any, 
    updateCache: LeadHistoryCacheUpdater = noopLeadHistoryCache
): Lead => {
    const mapped: Lead = {
        id: domainLead.id,
        name: domainLead.name,
        email: domainLead.getEmail(),
        whatsApp: domainLead.getWhatsApp(),
        value: domainLead.getValue(),
        stage: domainLead.stage,
        origin: domainLead.origin,
        agent: domainLead.agent,
        tags: domainLead.tags,
        observations: domainLead.observations,
        entryDate: domainLead.entryDate.toISOString(),
        date: domainLead.entryDate.toLocaleDateString('pt-BR'),
        contactId: domainLead.contactId,
        createdBy: domainLead.createdBy,
        creatorName: domainLead.creatorName,
        status: domainLead.status || 'open',
        wonAt: domainLead.wonAt?.toISOString(),
        lostAt: domainLead.lostAt?.toISOString(),
        lostReasonId: domainLead.lostReasonId,
        lossComments: domainLead.lossComments
    };

    updateCache(domainLead.id, domainLead.getValue(), domainLead.stage, domainLead.agent, domainLead.name);
    return mapped;
};
